<template>
  <article id="cart">
    <section class="shop">
      <a @click="cancel" class="shop__back">
        <i class="fa fa-angle-left"></i>
        <span>{{ $t('cart.goBackToStore') }}</span>
      </a>
      <div>
        <img class="shop__logo" :src="logo" />
      </div>
      <div class="shop__amount">{{ amount }}</div>
    </section>
    <div v-if="hasItems" class="articles--lg">
      <section v-for="itemCart in cart.items" :key="itemCart.sku" class="article">
        <div class="article__description">
          <img :src="itemCart.image" class="article__image__collapsed" />
          <div class="article__description__detail">
            <span class="article__description__detail__name bold">{{ itemCart.name }}</span>
            <span class="article__description__detail__amount">
              {{ $t('cart.quantity') }}: {{ itemCart.quantity }}
            </span>
          </div>
        </div>
        <div class="article__description__detail__price">{{ itemCart.amount }}</div>
      </section>
    </div>
    <div v-if="hasItems" class="articles--small">
      <div v-if="cart.items.length > 0" class="articles__count">
        <button @click="toggleArticles">
          {{ cart.items.length }} {{ $t('cart.items') }}
          <i
            class="fa"
            :class="{
              'fa-angle-down': !showArticles,
              'fa-angle-up': showArticles,
              'article-icon-expanded': showArticles,
              'article-icon-collapsed': !showArticles
            }"
          />
        </button>
      </div>
      <transition name="fade">
        <div v-if="showArticles">
          <section v-for="itemCart in cart.items" :key="itemCart.sku" class="article">
            <div class="article__description">
              <img :src="itemCart.image" class="article__image__collapsed" />
              <div class="article__description__detail">
                <span class="article__description__detail__name bold">{{ itemCart.name }}</span>
                <span class="article__description__detail__amount">
                  {{ $t('cart.quantity') }}: {{ itemCart.quantity }}
                </span>
              </div>
            </div>
            <div class="article__description__detail__price">{{ itemCart.amount }}</div>
          </section>
        </div>
      </transition>
    </div>
  </article>
</template>

<script>
export default {
  name: 'Cart',
  data() {
    return {
      logo: '',
      custom_css: '',
      cart: {
        items: [],
      },
      redirect_after: {
        cancel: '',
      },
      amount: null,
      currency: 'EUR',
      background: null,
      showArticles: false,
    };
  },

  computed: {
    hasItems() {
      return this.cart && this.cart.items && this.cart.items.length > 0;
    },
  },

  methods: {
    formatAmount(value) {
      const eurESLocale = Intl.NumberFormat('en-EN', {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        useGrouping: true,
      });
      return eurESLocale.format(value / 100).replace('€', '€ ');
    },
    cancel() {
      window.pwall.dispatch('cancel');
    },
    toggleArticles() {
      this.showArticles = !this.showArticles;
    },
  },
  beforeUpdate() {
    if (Number.isInteger(this.amount)) {
      this.amount = this.formatAmount(this.amount);
      this.cart.items.forEach((item, index) => {
        this.cart.items[index].amount = this.formatAmount(item.amount);
      });
    }
  },
  mounted() {
    window.set_cart = (data) => {
      this.logo = data.logo;
      this.custom_css = data.custom_css;
      this.cart = data.cart;
      this.redirect_after = data.redirect_after;
      this.amount = data.amount;
      this.currency = data.currency;
      if (this.custom_css) {
        document.head.innerHTML += `<style>${this.custom_css}</style>`;
      }
      if (this.cart && this.cart.items && this.cart.items.length) {
        document.getElementById('hpp-app').classList = 'cart-has-items';
      }
    };
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.fa {
  padding-right: 0.5em;
  transition: transform 0.5s ease;
}
#cart {
  font-family: 'Inter';
  .shop {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 9em 0 0 6em;
    &__text {
      font-size: 1.2em;
    }
    &__amount {
      font-size: 2.7em;
      font-weight: 500;
    }
    &__logo {
      max-height: 2em;
    }
    &__back {
      text-decoration: none;
      color: #1a1f36;
      font-size: 0.9em;
      position: absolute;
      margin-left: -40px;
      top: 40px;
      cursor: pointer;
      &:visited {
        color: #adadad;
      }
      &::after {
        content: "";
        display: block;
        width: 0;
        height: 1.5px;
        background: black;
        transition: width 0.3s;
      }
      &:hover::after {
        width: 100%;
        transition: width 0.7s;
      }
    }
  }
  .articles {
    padding-right: 3em;
    margin-left: 60px;
    &__count {
      display: none;
    }
    &--small {
      display: none;
    }
  }
  .article {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 2em;
    font-size: 14px;
    gap: 8em;
    padding: 0em 29em 0 7em;
    &__image {
      height: 350px;
      width: 350px;
      object-fit: cover;
      display: block;
      border-radius: 8px;
    }
    &__image__collapsed {
      width: 4em;
      height: 3.5em;
      object-fit: cover;
      border-radius: 3px;
    }
    &__description {
      display: flex;
      justify-items: flex-start;
      &__detail {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0 0 0 1.5em;
        white-space: nowrap;
        font-size: 14px;
        gap: 8px;

        &__price {
          white-space: nowrap;
        }
      }
    }
  }
  .article-icon-expanded {
    transform: translateY(1px) rotate(360deg) scale(1.2);
    opacity: 0.6;
    transition: transform 0.7s cubic-bezier(0.68, -0.55, 0.27, 1.55),
      opacity 0.6s ease-in-out;
  }

  .article-icon-collapsed {
    transform: translateY(0px) rotate(0deg) scale(1.3);
    opacity: 1;
    transition: transform 0.7s cubic-bezier(0.68, -0.55, 0.27, 1.55),
      opacity 0.6s ease-in-out;
  }

  .details__movile {
    display: none;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.6s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
@media (max-width: 1195px) {
  #cart {
    .articles--lg {
      display: none;
    }
    .articles--small {
      display: block;
      max-width: 350px;
    }
    .articles {
      padding-right: 1.5em;
      margin-left: 0;
      flex-direction: column;
      align-items: center;

      &__count {
        display: flex;
        flex-direction: column;
        color: #1a1f36;
        align-items: center;

        button {
          border: none;
          background: none;
          margin: 10px 0 10px 15px;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          color: #1a1f36;
          transition: transform 0.3s ease;
          i {
            margin-left: 3px;
          }
        }
      }
    }
    .article {
      margin-top: 1em;
    }
  }
}
@media (max-width: 980px) {
  #cart {
    .shop {
      align-items: center;
      padding: 4em 0 0 0;

      &__amount {
        font-size: 2.2em;
        font-weight: 500;
      }
      &__logo {
        margin-left: 0;
        max-width: 45%;
      }
      &__back {
        font-size: 0.8em;
        top: 2em;
        left: 5em;
      }
    }
    .article {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 6em;
      padding: 0;
      margin-top: 0.6em;
    }
  }
}
@media (max-width: 390px) {
  #cart {
    .article {
      gap: 3em;
      margin-top: 0.6em;

      &__description {
        &__detail {
          font-size: 12px;
        }
      }
    }
  }
}
@media (max-width: 360px) {
  #cart {
    .article {
      gap: 3em;
      margin-top: 0.6em;

      &__description {
        &__detail {
          font-size: 12px;
          &__price{
            font-size: 12px;
          }
        }
      }
    }
  }
}
@media (max-width: 320px) {
  #cart {
    .shop {
      padding: 3em 0 0 0;
      &__back {
        top: 1em;
        left: 4em;
      }
      &__amount {
        font-size: 2em;
      }
    }
    .articles__count button {
      margin: 8px 0 5px 15px;
    }
  }
}
</style>
